import { ButtonProps } from '@cfa/react-core';
import { CSSProperties, FC, ReactNode } from 'react';
import styled from 'styled-components';
import { LoadingButton } from '../Styled/LoadingButton';

const ButtonContent = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
`;

interface Props {
  id?: string;
  buttonText: string;
  handleClick?: () => void;
  variant?: ButtonProps['variant'];
  color?: ButtonProps['color'];
  styles?: CSSProperties;
  disabled?: boolean;
  size?: ButtonProps['size'];
  loading?: boolean;
  startIcon?: ReactNode;
}

const GlobalDrawerButton: FC<Props> = ({
  id,
  buttonText,
  handleClick,
  variant = 'filled',
  color,
  styles,
  disabled = false,
  size = 'lg',
  loading = false,
  startIcon,
}) => {
  return (
    <LoadingButton
      id={id}
      color={color}
      onPress={handleClick}
      isPending={loading}
      variant={variant}
      style={styles}
      isDisabled={disabled}
      size={size}
    >
      <ButtonContent>
        {startIcon}
        {buttonText}
      </ButtonContent>
    </LoadingButton>
  );
};

export default GlobalDrawerButton;
